import { createTheme, CssBaseline } from '@material-ui/core'
import { ThemeProvider } from '@material-ui/styles'
import { TopBar } from './layout/TopBar'
import { withAuthenticationRequired } from '@auth0/auth0-react'
import { useAppRoutes } from './layout/appRoutes'
import { ExecutionProvider } from './executions/ExecutionsListProvider'

function App(): JSX.Element {
  const appRoutes = useAppRoutes()
  const theme = createTheme({
    palette: {
      primary: {
        main: '#ff6a42',
      },
      secondary: {
        main: '#215af9',
      },
    },
  })

  return (
    <div className='App'>
      <ThemeProvider theme={theme}>
        <ExecutionProvider>
          <CssBaseline />
          <TopBar />
          {appRoutes}
        </ExecutionProvider>
      </ThemeProvider>
    </div>
  )
}

export default withAuthenticationRequired(App)
